import { useCallback, useEffect, useState, useMemo } from "react";
import InputControl from "../components/InputControl";
import ChatContainer from "../components/ChatContainer";
import PocketBase from "pocketbase";
import Logo from "../components/Logo";
import Flags from "../components/Flags";

export default function App({ lang = "tn" }) {
  if (lang === "tn") document.body.dir = "rtl";
  else document.body.dir = "ltr";

  const chatLang = {
    tn: [
      "أهلاً! أنا عبِير،  مدربتك في الدعم العاطفي. كيف يمكنني مساعدتك؟ أخبريني بما يشغلك.",
      "أعطني جهة الاتصال الخاصة بك حتى أتصل بك لاحقًا. الاسم الكامل ورقم الهاتف (Whatsup)",
      "شكرا سأتصل بك قريبا",
    ],
    fr: [
      "Bonjour ! Je suis Abir, votre coach en accompagnement émotionnel. Comment puis-je vous aider ? Parlez-moi de ce qui vous préoccupe.",
      "Donnez-moi vos coordonnées pour que je puisse vous recontacter. Votre nom complet et numéro de téléphone (WhatsApp)",
      "Merci, je serai en contact avec vous très bientôt",
    ],
    en: [
      "Hello! I'm Abir, your emotional support coach. How can I help you today? Feel free to share what's on your mind.",
      "Please share your contact details so I can get back to you. Your full name and phone number (WhatsApp)",
      "Thank you, I'll be in touch with you soon",
    ],
  };
  const systemPrompt = {
    role: "assistant",
    content: chatLang[lang][0],
  };
  const [prompt, setPrompt] = useState("");
  const [response, setResponse] = useState("");
  const [responseAdded, setResponseAdded] = useState(false);
  const [promptAdded, setPromptAdded] = useState(false);
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [chatHistory, setChatHistory] = useState([systemPrompt]);
  const [chatIndex, setChatIndex] = useState(0);
  const [problem, setProblem] = useState(null);
  const [info, setInfo] = useState(null);
  const BASE_URL = "https://tasty-activity.pockethost.io";
  const pb = useMemo(() => new PocketBase(BASE_URL), []);

  const handleResponse = useCallback(async () => {
    try {
      setLoadingResponse(true);

      const responseBody = {
        chatGptResponse: [chatLang[lang][1], chatLang[lang][2]],
      };
      setChatIndex(chatIndex + 1);
      setResponse(responseBody.chatGptResponse[chatIndex]);

      setResponseAdded(true);
      setPromptAdded(false);
      setLoadingResponse(false);
    } catch (error) {
      setLoadingResponse(false);
    }
  }, [chatHistory]);

  useEffect(() => {
    if (chatHistory?.length && promptAdded) {
      handleResponse();
    }
  }, [chatHistory, handleResponse, promptAdded]);

  useEffect(() => {
    if (response && responseAdded) {
      const newResponse = {
        role: "assistant",
        content: response,
      };
      setChatHistory((chatHistory) => [...chatHistory, newResponse]);

      setResponseAdded(false);
    }
  }, [response, responseAdded]);

  const getResponse = async () => {
    setPromptAdded(true);
    const newPrompt = {
      role: "user",
      content: prompt,
    };
    setChatHistory((chatHistory) => [...chatHistory, newPrompt]);
    if (chatHistory.length === 1) setProblem(newPrompt.content);
    if (chatHistory.length === 3) setInfo(newPrompt.content);
    setPrompt("");
  };

  const handleConsultation = useCallback(
    async (consultation) => {
      return await pb.collection("psy_consulting").create(consultation);
    },
    [pb]
  );

  if (chatHistory.length === 5) {
    handleConsultation({ problem, info });
  }

  return (
    <main
      className="flex min-h-screen flex-col px-4 sm:px-24 gap-y-4 pb-4"
      style={{ backgroundColor: "#1d328d" }}
    >
      <Logo />
      <Flags lang={lang} />
      <div className="grow overflow-y-auto">
        <ChatContainer chatHistory={chatHistory} lang={lang} />
      </div>
      <InputControl
        setPrompt={setPrompt}
        prompt={prompt}
        getResponse={getResponse}
        loadingResponse={loadingResponse}
        enabled={chatHistory.length === 5}
        lang={lang}
      />
    </main>
  );
}
